import * as Yup from 'yup';

export const FOUNDER_VALIDATION_SCHEMA = (
  t,
  { maxNewFunds = 0, fpgAssetsRequired, freeFpgOption },
) =>
  Yup.object().shape({
    new_funds: Yup.number()
      .min(0, t('founder_view.val_amount_cannot_be_less_than_0'))
      .max(maxNewFunds, t('founder_view.val_amount_cannot_be_more_than', { maxNewFunds }))
      .required(t('founder_view.val_new_funds_required_field')),
    has_accepted_terms: Yup.bool().oneOf([true], t('founder_view.val_accept_terms')),
    fpg: Yup.mixed().required(t('founder_view.val_fpg_is_required')),
    tariff_plan: Yup.mixed().required(t('founder_view.val_tariff_plan_is_required')),
    fpg_assets: Yup.array().when('fpg', {
      is: fpg => !!fpgAssetsRequired && fpg?.id === freeFpgOption?.id,
      then: () => Yup.array().min(1),
    }),
  });

export const CO_FOUNDER_VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    has_accepted_terms: Yup.bool().oneOf([true], t('co_founder_view.val_accept_terms')),
    has_reviewed_settings: Yup.bool().oneOf([true], t('co_founder_view.val_accept_terms')),
  });
